module.exports = __webpack_public_path__ + "static/media/altas.6d3266a6.svg";